import { render, staticRenderFns } from "./DisableCategoryModal.vue?vue&type=template&id=f09db2da&scoped=true"
import script from "./DisableCategoryModal.vue?vue&type=script&lang=ts"
export * from "./DisableCategoryModal.vue?vue&type=script&lang=ts"
import style0 from "./DisableCategoryModal.vue?vue&type=style&index=0&id=f09db2da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f09db2da",
  null
  
)

export default component.exports